import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

export interface UtmParams {
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  utm_term: string;
  utm_content: string;
}

const KEYS: (keyof UtmParams)[] = [
  'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
];
const P = 'nerd_utm_';
const VISIT_FLAG = 'nerd_visit_recorded';

@Injectable({ providedIn: 'root' })
export class UtmService {
  constructor() {
    this.captureFromUrl();
    this.trackVisit();
  }

  private captureFromUrl(): void {
    const params = new URLSearchParams(window.location.search);

    // ?ref= maps to utm_source when no explicit utm_source is in the URL
    const ref = params.get('ref');
    if (ref && !params.get('utm_source') && !sessionStorage.getItem(P + 'utm_source')) {
      sessionStorage.setItem(P + 'utm_source', ref);
      const medium = params.get('utm_medium') ?? 'referral';
      if (!sessionStorage.getItem(P + 'utm_medium')) {
        sessionStorage.setItem(P + 'utm_medium', medium);
      }
    }

    // First-touch: store UTMs from URL only if not already captured this session
    for (const key of KEYS) {
      const val = params.get(key);
      if (val && !sessionStorage.getItem(P + key)) {
        sessionStorage.setItem(P + key, val);
      }
    }
  }

  private trackVisit(): void {
    if (sessionStorage.getItem(VISIT_FLAG)) return;

    const utms = this.get();
    const body = {
      utmSource: utms.utm_source || null,
      utmMedium: utms.utm_medium || null,
      utmCampaign: utms.utm_campaign || null,
      utmTerm: utms.utm_term || null,
      utmContent: utms.utm_content || null,
      landingPath: window.location.pathname,
    };

    fetch(`${environment.apiBaseUrl}/visits`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
      .then(() => sessionStorage.setItem(VISIT_FLAG, '1'))
      .catch(() => {});
  }

  // Empty string (not a sentinel like 'direct'/'none') so a real campaign that explicitly
  // tags utm_source=direct isn't indistinguishable from "nothing was captured" — see
  // trackVisit() / SignupService.signup(), which now both treat falsy as "omit" rather than
  // ever having to special-case the literal word 'direct'.
  get(): UtmParams {
    return {
      utm_source:   sessionStorage.getItem(P + 'utm_source')   ?? '',
      utm_medium:   sessionStorage.getItem(P + 'utm_medium')   ?? '',
      utm_campaign: sessionStorage.getItem(P + 'utm_campaign') ?? '',
      utm_term:     sessionStorage.getItem(P + 'utm_term')     ?? '',
      utm_content:  sessionStorage.getItem(P + 'utm_content')  ?? '',
    };
  }
}
